/**
 * UnitsSizesRange
 */
export const unitsSizesRange = [
    { range: { from: 0, to: 100 }, title: 'الي 100 متر' },
    { range: { from: 101, to: 150 }, title: 'من 101 الي 150 متر' },
    { range: { from: 151, to: 200 }, title: 'من 151 الي 200 متر' },
    { range: { from: 201, to: 250 }, title: 'من 201 الي 250 متر' },
    { range: { from: 251, to: null }, title: 'من 251 متر فاكثر' },
];

/**
 * UnitsPricesRange
 */
export const unitsPricesRange = [
    { range: { from: 0, to: 500000 }, title: 'الي 500 الف' },
    { range: { from: 500001, to: 850000 }, title: 'من 501 الف الي 850 الف' },
    { range: { from: 851000, to: 1000000 }, title: 'من 851 الف الي 1 مليون' },
    { range: { from: 1000000, to: 1400000 }, title: 'من 1 مليون الي 1 مليون و 400 الف' },
    { range: { from: 1400000, to: 1800000 }, title: 'من 1 مليون و 400 الف الي 1 مليون و 800 الف' },
    { range: { from: 1800000, to: null }, title: 'من 1 مليون و 800 الف فاكثر' }
];

/**
 * UnitsRoomsRange
 */
export const unitsRoomsRange = [
    { range: { from: 1, to: 3 }, title: 'من 1 الي 3 غرف' },
    { range: { from: 4, to: 5 }, title: 'من 4 الي 5 غرف' },
    { range: { from: 6, to: 7 }, title: 'من 6 الي 7 غرف' },
    { range: { from: 8, to: null }, title: 'من 8 غرف فاكثر' },
];